import React, { ReactNode } from 'react';
import Checkbox from 'src/components/Checkbox/Checkbox';
import './bulk-select-all-row.scss';

export interface BulkSelectAllRowProps {
  checked: boolean;
  onChange: () => void;
  label: string;
  disabled?: boolean;
  rightSlot?: ReactNode;
}

const BulkSelectAllRow = ({
  checked,
  onChange,
  label,
  disabled = false,
  rightSlot,
}: BulkSelectAllRowProps) => {
  return (
    <div className="bulk-select-all-row">
      <label className="bulk-select-all-row-control">
        <Checkbox
          checked={checked}
          value={checked}
          onChange={onChange}
          disabled={disabled}
        />
        <span className="bulk-select-all-row-label">{label}</span>
      </label>

      {rightSlot && (
        <div className="bulk-select-all-row-meta">{rightSlot}</div>
      )}
    </div>
  );
};

export default BulkSelectAllRow;
